module.exports = __webpack_public_path__ + "static/img/outlineBorder1.b16b792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/outlineBorder1.png
// module id = 6Bbt
// module chunks = 1